import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import LeasingInterestsListBrowser from './LeasingInterestsListBrowser';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import { defaultLeasingInterest, leasingInterestModalVar } from 'features/leasingInterests/variables';
import { IconButton } from '@totalsoft/rocket-ui';
import HeaderPortal from 'components/layout/HeaderPortal';
import { useTranslation } from 'react-i18next';
import { ADMIN_LEASING_INTERESTS_READ, ADMIN_LEASING_INTERESTS_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();

  const canWrite = usePermission(ADMIN_LEASING_INTERESTS_WRITE);

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_LEASING_INTERESTS_WRITE} withForbiddenPage={false}>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
            onClick={() => leasingInterestModalVar({ open: true, item: defaultLeasingInterest })}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_INTERESTS_READ}>
        <LeasingInterestsListBrowser canWrite={canWrite} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
